var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "1320px", persistent: "" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Voltar ")]
              ),
              _c(
                "BaseButton",
                { attrs: { dark: "" }, on: { click: _vm.openSearchLong } },
                [_vm._v(" Ver lista completa ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { dark: "", loading: _vm.loading, hidden: "" },
                  on: { click: _vm.dontFind }
                },
                [
                  _c("strong", [_vm._v(" + ")]),
                  _vm._v(" Ativo não encontrado ")
                ]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: { click: _vm.enviar }
                },
                [_vm._v(" Inserir ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Selecione o ativo" } }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { class: _vm.ativosSelecionados.length ? "col-8" : "col-12" },
          [
            _c(
              "form",
              {
                attrs: { action: "#" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "input-group align-items-center" },
                  [
                    _c("v-text-field", {
                      staticClass: "input short-search",
                      attrs: {
                        "append-icon": " ",
                        "background-color": "#E4E0E6",
                        "item-value": "id",
                        "item-text": "name",
                        label: "",
                        "full-width": "",
                        placeholder: "Pesquisar"
                      },
                      model: {
                        value: _vm.searchAsset,
                        callback: function($$v) {
                          _vm.searchAsset = $$v
                        },
                        expression: "searchAsset"
                      }
                    }),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-icon btn-icon-secondary align-self-center",
                        style: {
                          "background-color": "#E4E0E6"
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "19.276",
                              height: "19.966",
                              viewBox: "0 0 19.276 19.966"
                            }
                          },
                          [
                            _c("path", {
                              staticClass: "fill",
                              attrs: {
                                d:
                                  "M19.967 18.186l-4.752-4.942a8.058 8.058 0 1 0-6.17 2.879 7.975 7.975 0 0 0 4.618-1.459l4.788 4.98a1.051 1.051 0 1 0 1.516-1.458zM9.045 2.1a5.958 5.958 0 1 1-5.958 5.961A5.965 5.965 0 0 1 9.045 2.1z",
                                transform: "translate(-.984)"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              [
                _c("v-data-table", {
                  staticClass: "table-pointer",
                  attrs: {
                    headers: _vm.headersAtivos,
                    loading: _vm.loadingAssets,
                    items: _vm.ativos,
                    search: _vm.searchAsset,
                    height: "220",
                    "fixed-header": ""
                  },
                  on: { "click:row": _vm.selectAsset },
                  scopedSlots: _vm._u([
                    {
                      key: "item.aberto",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-right": "18px" },
                              attrs: {
                                small: "",
                                color: value ? "success" : "red"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    value
                                      ? "mdi-lock-open-outline"
                                      : "mdi-lock-outline"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.utilizar",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c("div", { class: { "text-success": value } }, [
                            _vm._v(" " + _vm._s(value ? "Sim" : "Não") + " ")
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.nome_ativo",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c("div", { staticClass: "asset-name-cell" }, [
                            _vm._v(_vm._s(value || "-"))
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.recomendacao",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          value
                            ? _c("BaseStatus", {
                                attrs: {
                                  soft: "",
                                  content: _vm.getRecomendacaoLabel(value),
                                  color: _vm.getRecomendacaoStatusColor(value)
                                }
                              })
                            : _c("small", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.setor",
                      fn: function(ref) {
                        var value = ref.value
                        return [_c("small", [_vm._v(_vm._s(value || "-"))])]
                      }
                    },
                    {
                      key: "item.tags",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          Array.isArray(value) && value.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "d-flex align-center flex-wrap",
                                  staticStyle: { gap: "4px" }
                                },
                                [
                                  _vm._l(value.slice(0, 2), function(tag, idx) {
                                    return _c(
                                      "v-chip",
                                      {
                                        key: idx,
                                        attrs: { "x-small": "", outlined: "" }
                                      },
                                      [_vm._v(" " + _vm._s(tag) + " ")]
                                    )
                                  }),
                                  value.length > 2
                                    ? _c(
                                        "v-chip",
                                        {
                                          attrs: { "x-small": "", outlined: "" }
                                        },
                                        [
                                          _vm._v(
                                            " +" +
                                              _vm._s(value.length - 2) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            : _c("small", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.comentario",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                color: value ? "primary" : "grey"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    value
                                      ? "mdi-comment-text"
                                      : "mdi-comment-outline"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]
        ),
        _vm.ativosSelecionados.length
          ? _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("p", { staticClass: "subhead text-bold" }, [
                  _vm._v(" Ativos selecionados ")
                ]),
                _c("v-divider"),
                _c(
                  "v-list",
                  [
                    _c(
                      "v-list-item-group",
                      {
                        staticStyle: {
                          "max-height": "300px",
                          "overflow-y": "auto"
                        }
                      },
                      _vm._l(_vm.ativosSelecionados, function(a) {
                        return _c(
                          "v-list-item",
                          { key: a.id_ativo },
                          [
                            _c(
                              "v-list-item-content",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.openEdit(a)
                                  }
                                }
                              },
                              [
                                _c("v-list-item-title", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between",
                                      staticStyle: { "max-width": "100%" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "selected-asset-name" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(a.nome_ativo || "—") +
                                              " "
                                          )
                                        ]
                                      ),
                                      a.percentual &&
                                      _vm.getNumber(a.percentual)
                                        ? _c("small", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  a.percentual +
                                                    ((a.percentual
                                                      ? a.percentual.toString()
                                                      : ""
                                                    ).includes("%")
                                                      ? ""
                                                      : "%")
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _c("small", [
                                            _vm._v(" " + _vm._s(a.pl) + " ")
                                          ])
                                    ]
                                  )
                                ]),
                                _c("v-list-item-subtitle", [
                                  _c("small", [
                                    _vm._v(" " + _vm._s(a.classe) + " ")
                                  ])
                                ]),
                                _c("hr")
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-action",
                              { staticClass: "ml-1" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { small: "", icon: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deselect(a)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v(" mdi-close ")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("EditarAtivo", {
        attrs: {
          bus: _vm.busModal,
          "pl-total": _vm.plTotal,
          "pl-sugerido": _vm.plSugerido,
          "pl-nao-alocado": _vm.plNaoAlocado,
          "ativos-atuais": _vm.ativosAtuais,
          janelaTempo: _vm.janelaTempo,
          qualificado: _vm.qualificado,
          classes: _vm.classes,
          ativosSelecionados: _vm.ativosSelecionados
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }